import { required, email } from '@validations'
import VueRecaptcha from 'vue-recaptcha'
import store from '@/store'
import AuthApis from '@/services/apis/auth'

const auth = new AuthApis()
export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      required,
      email,
      pending: false,
      form: {
        email: '',
        recaptcha: null,
      },
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, global-require
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    sitekey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY
    },
  },
  methods: {
    async submit() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        this.pending = true
        auth.forgotPassword(this.form).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 3000,
            showConfirmButton: false,
          })
          this.$router.push({ name: 'login' })
        }).finally(() => {
          this.onCaptchaExpired()
          this.pending = false
        })
      }
    },
    onVerify(response) {
      this.form.recaptcha = response
    },
    async onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.form.recaptcha = null
    },
  },
}
